import React, { ReactElement, type ReactNode } from "react"
import Show from "components/Show"
import useFeatureFlag from "hooks/useFeatureFlag"
import type { FeatureFlags } from "models/FeatureFlags"

export interface FeatureFlagComponentGuardProps {
  feature: keyof FeatureFlags
  invert?: boolean
  loadingComponent?: ReactNode
  fallbackComponent?: ReactNode
  children: ReactNode
}

const FeatureFlagComponentGuard = ({
  feature,
  invert = false,
  children,
  loadingComponent = null,
  fallbackComponent
}: FeatureFlagComponentGuardProps) => {
  const { isFlagActive, isLoading } = useFeatureFlag(feature)

  if (isLoading) {
    return loadingComponent as ReactElement
  }

  return (
    <Show when={isFlagActive === !invert} fallback={fallbackComponent}>
      {children}
    </Show>
  )
}

export default FeatureFlagComponentGuard
